import { Button, Flex, Layout, Typography, theme } from 'antd'
import React from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import { PlusOutlined } from '@ant-design/icons'
const { Content } = Layout

const AdminDashboard = () => {

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <>
      <Layout>
        <Header bgColor={colorBgContainer}/>
        <Content
          style={{
            padding: '0 48px',
          }}
        >
          <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 36,
              borderRadius: borderRadiusLG,
              marginTop: 16
            }}
          >
            <Typography.Title>
              Admin Dashboard
            </Typography.Title>
          </div>
        </Content>
        <Footer/>
      </Layout>
    </>
  )
}

export default AdminDashboard